import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axiosInstance from '../api/axios';
import { updatePendingStockRequestsCount } from '../redux/actions/stockRequestActions';

export const usePendingStockRequests = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchPendingCount = async () => {
            const accessToken = localStorage.getItem('authToken');
            if (!accessToken) return;

            try {
                const headers = { 
                    Authorization: `Bearer ${accessToken}` 
                };
                const res = await axiosInstance.get('stock-requisition', { headers });
                const raw = res?.data?.data?.data ?? [];
                const formattedData = Array.isArray(raw) ? raw : [raw]?.filter(Boolean);
                
                const pendingCount = formattedData?.filter(req => req?.status === 'PENDING')?.length;
                dispatch(updatePendingStockRequestsCount(pendingCount));
            } catch (err) {
                console.error('Failed to fetch pending stock requests count:', err);
            }
        };

        fetchPendingCount();

        // Optional: Refresh count every 5 minutes
        const interval = setInterval(fetchPendingCount, 5 * 60 * 1000);
        return () => clearInterval(interval);
    }, [dispatch]);
};